import { render, staticRenderFns } from "./AssistMaterialSelect.vue?vue&type=template&id=6a83ea87&scoped=true&lang=pug&"
import script from "./AssistMaterialSelect.vue?vue&type=script&lang=ts&"
export * from "./AssistMaterialSelect.vue?vue&type=script&lang=ts&"
import style0 from "./AssistMaterialSelect.vue?vue&type=style&index=0&id=6a83ea87&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a83ea87",
  null
  
)

export default component.exports